import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

const LawFirmSelectionDialog = ({
  showDialog,
  selectedOption,
  setSelectedOption,
  lawFirmOptions,
  handleLawFirmSelection,
}) => {
  return (
    <Dialog open={showDialog} fullWidth maxWidth="sm">
      <DialogTitle>Select the Law Firm you are operating for</DialogTitle>
      <DialogContent>
        <RadioGroup
          value={selectedOption}
          onChange={(e) => setSelectedOption(Number(e.target.value))}
        >
          {lawFirmOptions.map((lf) => (
            <FormControlLabel
              key={lf.lawfirm_id}
              value={lf.lawfirm_id}
              control={<Radio />}
              label={`${lf.lawfirm_name} (${lf.location_name})`}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleLawFirmSelection}
          disabled={!selectedOption}
          variant="contained"
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LawFirmSelectionDialog;
